import { AddCompanyForm } from '@/view/companies/CompaniesCreate/AddCompanyForm';
import { formDefaultValues } from '@/view/companies/CompaniesCreate/AddCompanyForm/defaultValues';

function CompaniesCreate(): JSX.Element {
  return <AddCompanyForm formDefaultValues={formDefaultValues} />;
}

export default CompaniesCreate;
